<!-- No pipelines message -->
<div
  class="flex-row align-items-center justify-content-center"
  style="margin: 0 auto; padding: 48px"
  *ngIf="noPipelines && !loading"
>
  {{ emptyMessageKey | translate }}
</div>

<!-- Table content wrapper with loading overlay -->
<div
  class="table-wrapper"
  [class.loading]="loading"
  [style.min-height.px]="containerHeight"
  *ngIf="!noPipelines"
>
  <!-- Loading overlay - preserves the space while showing loading state -->
  <div class="loading-overlay" *ngIf="loading">
    <div class="loading-content">
      <i class="ri-loader-4-line spin"></i>
      {{ 'info.loading_data' | translate }}
    </div>
  </div>

  <!-- Table content - visible but dimmed during loading -->
  <table
    mat-table
    [dataSource]="items"
    class="spotlab-table"
    matSort
    style="width: 100%"
    [class.dimmed]="loading"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.name' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let pipeline" class="name-cell">
        {{ getPipelineName(pipeline.name) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="environment">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.environment' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let pipeline" class="env-cell">
        <span class="env-badge" [class.env-cloud]="pipeline.env === 'cloud'" [class.env-edge]="pipeline.env === 'edge'">
          {{
            (pipeline.env === 'cloud' ? 'core.cloud' : pipeline.env === 'edge' ? 'core.edge' : 'core.no_env') | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="usedByMethodTypes">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.method_types' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let pipeline" class="count-cell">
        <ts-loading-attribute
          icon="ri-flask-line"
          [value]="pipeline.usedByMethodTypes"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="numSteps">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'core.steps' | translate | uppercase }}
      </th>
      <td mat-cell *matCellDef="let pipeline" class="count-cell last-data-cell">
        <ts-loading-attribute
          icon="ri-git-branch-line"
          [value]="pipeline.numSteps"
          class="flex-row align-items-center justify-left"
        ></ts-loading-attribute>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let pipeline" class="icon-cell">
        <button
          class="icon-button"
          type="button"
          (click)="editClicked.emit(pipeline); $event.stopPropagation()"
          data-cy="pipeline-edit"
        >
          <i class="ri-pencil-line"></i>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="assigned">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let pipeline" class="icon-cell">
        <button
          class="icon-button assigned-toggle"
          [class.assigned]="pipeline.assigned"
          type="button"
          [matTooltip]="(pipeline.assigned ? 'label.unassign' : 'label.assign') | translate"
          [matTooltipShowDelay]="1000"
          (click)="assignedToggled.emit(pipeline); $event.stopPropagation()"
          data-cy="pipeline-assigned"
        >
          <i [class]="pipeline.assigned ? 'ri-checkbox-circle-fill' : 'ri-add-circle-line'"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="visibleColumns"></tr>
    <tr mat-row *matRowDef="let pipeline; columns: visibleColumns" class="clickable-row"></tr>
  </table>
</div>
